// 基本配置
const basicAuth = 'Basic anR5YXBpOjljY2E4MjdjY2ZiOTRmYjhhYmYyZDI1NWJhOTczZmQw'

let url = window.location.host.indexOf('jkxjxw') === -1 ? 'http://testfuwu-nrsc.jtyjy.com' : 'https://fuwu-nrsc.jkxjxw.com'

const bkResource = `${url}/v1/nrsc/service-document/documents/`
const zipResource = `${url}/v1/nrsc/service-document/zip-doc-ref/`

export {
  basicAuth,
  bkResource,
  zipResource
}





// WEBPACK FOOTER //
// ./src/utils/constant.js